<template>
  <div class="login-page items-center justify-center">
    <v-card :loading="loading" class="mx-auto item-card pa-md-12 pa-5">
      <warnningComponent
        v-bind:textInfo.sync="textWarning"
        v-bind:typestatus.sync="typeWarning"
        v-bind:alert.sync="showWarnnig"
      ></warnningComponent>
      <div class="logo mb-5">
        <v-img src="../../assets/ssru-logo.png"></v-img>
      </div>
      <div class="titile my-5">
        <v-card-title
          primary-title
          class="headline justify-center pa-0 font-weight-bold"
        >ลงทะเบียนสำเร็จ</v-card-title>
        <p class="text-center my-5">ระบบได้รับข้อมูลการลงทะเบียนของท่านเรียบร้อยแล้ว</p>
        <p class="text-center my-5">
          <i>มหาวิทยาลัยราชภัฏสวนสุนันทา</i>
        </p>
      </div>
      <!-- <div class="text-center mt-2 mb-8">
          <v-btn color="success" class="md-w-40 xs-full-width" large rounded>Go to Login</v-btn>
      </div>-->
    </v-card>
  </div>
</template>
<script>
export default {
  name: "register-success"
};
</script>
<style scoped>
.logo {
  width: 20%;
  margin: 0 auto;
}
.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-card {
  width: 30%;
  min-height: 300px;
}

.md-w-100 {
  width: 100%;
}
.md-w-40 {
  width: 40%;
}
.or-line {
  width: 74%;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  line-height: 0.1em;
  margin: 10px auto 20px;
}
.or-line span {
  background: #fff;
  padding: 0 30px;
  color: #e0e0e0;
}
.w-auto {
  width: auto !important;
}
.m-auto {
  margin: 0 auto !important;
}
.md-position-bottom-0 {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
.md-position-relative {
  position: relative !important;
}

@media only screen and (max-width: 768px) {
  .or-line {
    width: 94%;
  }
  .item-card {
    width: 100%;
    /* min-height: 90%; */
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
  .xs-position-unset {
    position: unset !important;
  }
  .xs-full-width {
    width: 100% !important;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .item-card {
    width: 100%;
    min-height: 560px;
    height: 100%;
  }
  .or-line {
    width: 94%;
  }
  .login-page {
    height: 100%;
    align-items: center;
  }
  .xs-position-unset {
    position: unset !important;
  }

  .md-hidden {
    display: none;
  }
  .md-w-40 {
    width: 40% !important;
  }
  .xs-full-width {
    width: 40% !important;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 60%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 50%;
  }
}
</style>